export const state = {
    frame: null,
    targetOrigin: "",
    listener: null
};
export var __globalDispatch = {};
export var __staticDispatch = {};
export var classDispatch = {};
export var __initPromise = null;
export async function assureLoaded() {
    if (__initPromise) {
        await __initPromise;
    }
}
export function setLoading(promise) {
    __initPromise = promise;
}
let __nonce = 0;
export const getNonce = () => {
    return __nonce++;
};
